/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';
import SvgIcon from '@material-ui/core/SvgIcon';

const CircleTick = (props) => (
  <SvgIcon
    style={{
      width: '84px',
      height: '84px',
    }}
    viewBox="0 0 84 84"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <title>{props.title}</title>
    <g id="Registration-UI" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g id="4.1---Results---Desktop-HD" transform="translate(-678.000000, -250.000000)">
        <g id="Circle-Tick" transform="translate(680.000000, 252.000000)">
          <polygon
            id=""
            fill="#00BF0D"
            points="62.2727273 23 65 25.6832298 32.2727273 57.8819876 30.9090909 59 29.5454545 57.8819876 15 43.5714286 17.7272727 40.8881988 30.9090909 53.9689441"
          />
          <circle
            id="Oval"
            stroke="#00BF0D"
            strokeWidth="3"
            fillRule="nonzero"
            cx="40"
            cy="40"
            r="40"
          />
        </g>
      </g>
    </g>
  </SvgIcon>
);

CircleTick.propTypes = {
  title: PropTypes.string,
};

CircleTick.defaultProps = {
  title: '',
};

export default CircleTick;
